// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "vendor-onnx" + ".bundle." + "8e9cdcd9058b6e391f01" + ".js";
};